import { render, staticRenderFns } from "./KycDetail.vue?vue&type=template&id=090dadb0&scoped=true"
import script from "./KycDetail.vue?vue&type=script&lang=js"
export * from "./KycDetail.vue?vue&type=script&lang=js"
import style0 from "./KycDetail.vue?vue&type=style&index=0&id=090dadb0&prod&lang=scss&scoped=true"
import style1 from "./KycDetail.vue?vue&type=style&index=1&id=090dadb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090dadb0",
  null
  
)

export default component.exports